
import { Checkbox } from '@atlaskit/checkbox';
import React from 'react';

import { Icon, IconRemoteControlStart } from '../../base/icons';
import Audio from '../../base/media/components/Audio';
import { getBrandingColorPalette } from '../../base/styles';

const TEST_SOUND_PATH = 'sounds/ring.wav';

/**
 * Functional component wrapper to use tss-react styles.
 */
type ContentProps = {
    audioElementReady: (Object) => void,
    interfaceConfig: Object,
    isNoiseSuppressionEnabledProps: boolean,
    onClick: () => void,
    onNoiseSuppressionChange: (Object) => void,
    t: Function
};


/**
 * Functional React component for rendering the audio output preview UI.
 *
 * @param {ContentProps} props - The props for the component.
 * @returns {ReactElement}
 */
export default function AudioOutputPreviewContent(props: ContentProps) {
    const {
        audioElementReady,
        interfaceConfig,
        isNoiseSuppressionEnabledProps,
        onClick,
        onNoiseSuppressionChange,
        t
    } = props;
    const testButtonStyle = {
        background: getBrandingColorPalette(interfaceConfig)?.primary,
        color: interfaceConfig ? getBrandingColorPalette(interfaceConfig)?.accent1 : '#fff'
    };

    return (
        <div className = 'audio-output-preview'>
            {/* <a onClick={onClick}>
                {t('deviceSelection.testAudio')}
            </a> */}
            <button
                onClick = { onClick }
                style = { testButtonStyle }
                type = 'button'>
                <Icon
                    fillColor = { interfaceConfig ? getBrandingColorPalette(interfaceConfig)?.accent1 : '#fff' }
                    src = { IconRemoteControlStart } />
                <span className = 'audio-output-preview-text'>{t('deviceSelection.testAudio')}</span>
            </button>
            <div className = { 'noise-suppression-container' }>
                <Checkbox
                    className = 'custom-checkbox'
                    isChecked = { isNoiseSuppressionEnabledProps }
                    label = { t('settingsView.noiseSuppression') }
                    name = 'noise-suppression-checkbox'
                    onChange = { onNoiseSuppressionChange } />
            </div>
            <Audio
                setRef = { audioElementReady }
                src = { TEST_SOUND_PATH } />
        </div>
    );
}
